import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { AssessmentService } from "../../../services/assessment.service";

@Component({
    selector: 'app-delete-warning',
    templateUrl: './delete-warning.component.html',
    styleUrls: ['./delete-warning.component.scss'],
    standalone: false
})
export class DeleteWarningComponent implements OnInit  {
  deleteElementsCounterString: string = "";
  affectedElementsCounter: number = 0;
  moreDeleted: number = 0;

  constructor(
    public dialogRef: MatDialogRef<DeleteWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.deleteElementsCounterString = this.data.deleteElementsCounterString;
    this.moreDeleted = this.data.moreDeleted;
    this.affectedElementsCounter = this.data.affectedElementsCounter;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
  confirmDeleteAssessmentElement() {
    this.dialogRef.close(true);
  }

}
